import api from "../../instance/api";
import {
  errorClientMemberList,
  startClientMemberList,
  successClientMemberList,
  errorClientMemberStats,
  startClientMemberStats,
  successClientMemberStats,
  errorClientMemberDetails,
  startClientMemberDetails,
  successClientMemberDetails,
} from "../../slice/Client-Member/index";

// ✅ 1. Get Client Member List with filters & pagination
const getClientMemberListApi = (filters = {}) => async (dispatch) => {
  dispatch(startClientMemberList());

  try {
    const res = await api.get(`/user/admin-users-list`, {
      params: {
        name: filters.name || undefined,
        gender: filters.gender || undefined,
        riskStatus: filters.riskStatus || undefined,
        startDate: filters.startDate || undefined, // format: 'YYYY-MM-DD'
        endDate: filters.endDate || undefined,     // format: 'YYYY-MM-DD'
        page: filters.page ?? 0,
        size: filters.size ?? 10,
          status: filters.status || undefined,
      }
    });

    const payload = {
  list: res?.data?.content || [],
  total: res?.data?.totalElements || 0
};
dispatch(successClientMemberList(payload));


    console.log("Client Member List response:", res);
  } catch (err) {
    dispatch(errorClientMemberList(err?.response?.data?.message));
    console.error("Client Member List error:", err);
  }
};


// ✅ 2. Get Client Member Stats
const getClientMemberStatsApi = () => async (dispatch) => {
  dispatch(startClientMemberStats());
  try {
    const res = await api.get(`/admin/member-stats`);
    const payload = res?.data?.payload || null;
    dispatch(successClientMemberStats(payload));
    console.log("Client Member Stats response:", res);
  } catch (err) {
    dispatch(errorClientMemberStats(err?.response?.data?.message));
    console.log("Client Member Stats error:", err);
  }
};

// ✅ 3. Get Client Member Details by ID
const getClientMemberDetailsApi = (clientId) => async (dispatch) => {
  dispatch(startClientMemberDetails());
  try {
    const res = await api.get(`/admin/getAllUserDetails/${clientId}`);
    const payload = res?.data || null;
    dispatch(successClientMemberDetails(payload));
    console.log("Client Member Details response:", res);
  } catch (err) {
    dispatch(errorClientMemberDetails(err?.response?.data?.message));
    console.log("Client Member Details error:", err);
  }
};

export {
  getClientMemberListApi,
  getClientMemberStatsApi,
  getClientMemberDetailsApi,
};
